<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-card tile flat>
            <v-card-text>
                <v-list subheader expand class='mb-0 pb-0'>
                    <v-list-item @click="visibility.create=true" v-if='statplaceCreateAllowed'>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Добавить источник</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>add</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item @click="visibility.info=true" v-if='$store.state.userData.user.superuser'>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Информация о подключении</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-magnify-plus-outline</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item @click="visibility.state=true" v-if='$store.state.userData.user.superuser'>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Состояние загрузки</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-download-network-outline</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item @click="visibility.factors=true" v-if='factorsAllowed'>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Мультипликаторы расходов</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>mdi-contrast</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item color="red" @click="updateView" v-if='$store.state.userData.user.superuser'
                                 :disabled="isViewButtonDisabled">
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Пересобрать вьюху</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>add</v-icon>
                        </v-list-item-action>
                    </v-list-item>

                    <v-list-item color="red" @click="updateFincards"
                                 v-if='$store.state.userData.user.superuser && project.project_id == 205'
                                 :disabled="isFincardUploadButtonDisabled">
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Обновить финкарты</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>refresh</v-icon>
                        </v-list-item-action>
                    </v-list-item>

                    <v-list-item color="red" @click="updatePMReports"
                                 v-if='$store.state.userData.user.superuser && project.project_id == 178'
                                 :disabled="isPmReportsUploadButtonDisabled">
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Обновить ПМ отчеты</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>refresh</v-icon>
                        </v-list-item-action>
                    </v-list-item>


                    <v-list-item>
                        <v-list-item-content style="margin-left: 12px;">
                            <v-checkbox
                                    v-model="showNonActive"
                                    :label="`Показать выключенные источники`"
                            ></v-checkbox>
                        </v-list-item-content>

                    </v-list-item>
                    <v-snackbar v-model="snackbar"> Задача на пересборку отдана</v-snackbar>
                    <v-snackbar v-model="snackbar2"> Обновление финкарт запущено</v-snackbar>
                    <v-snackbar v-model="snackbar3"> Обновление ПМ отчетов запущено</v-snackbar>
                    <v-progress-linear :color='$store.getters.uiAccent' class='mb-0 py-0 mt-0' height='1'
                                       :active='indicator.list' :indeterminate='true'></v-progress-linear>
                    <v-divider v-if='!indicator.list'></v-divider>
                    <template v-if='!statplaces.length && !indicator.list'>
                        <v-list-item link>
                            <v-list-item-content class='pl-4'>
                                <v-list-item-title>Рекламные аккаунты не подключены</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item link>
                            <v-list-item-content class='pl-4'>
                                <v-list-item-title>Проверить экспорт</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon>mdi-progress-check</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>
                    </template>
                    <v-list-group
                        no-action
                        v-for='(value, key) in groupedStatplaces'
                        :key='key'
                        style='border-bottom: 1px solid;border-color:#EEEEEE;'
                    >
                        <template v-slot:activator>
                            <v-list-item style='background: transparent !important;'
                                         :two-line='!$vuetify.breakpoint.smAndUp' class='mx-0 px-0'>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-layout row wrap mx-4>
                                            <span
                                                class='font-weight-medium'>{{value.source_type_name}} {{value.show}}</span>
                                            <v-chip
                                                small
                                                outlined
                                                color='blue lighten-3'
                                                class='ml-auto'
                                                v-if='$vuetify.breakpoint.smAndUp'
                                            >{{meanings[value.source_type_meaning]}}
                                            </v-chip>
                                            <span :class='$vuetify.breakpoint.smAndUp? "ml-2":""'>
                                                <template v-if='indicator.updates' tag='span'>
                                                    <v-progress-circular indeterminate :color='$store.getters.uiAccent'
                                                                         size='16' class='ma-0'
                                                                         :width='1'></v-progress-circular>
                                                </template>
                                                <template v-else>
                                                    <span v-if='value.time' class='caption font-weight-light'>Обновлено <span
                                                        class='font-weight-regular'>{{value.time}}</span></span>
                                                    <span v-else class='caption font-weight-light'>Не обновлялось</span>
                                                </template>
                                            </span>
                                        </v-layout>
                                    </v-list-item-title>
                                </v-list-item-content>
                                <!--v-list-item-content>
                                    <v-list-item-title>
                                        <div style='display: flex; justify-content: space-between;align-items: center;'>
                                            <span class = 'font-weight-medium'>{{value.source_type_name}}</span>
                                            <span>{{meanings[value.source_type_meaning]}}</span>
                                            <template v-if='indicator.updates' tag='span'>
                                                <v-progress-circular indeterminate :color='$store.getters.uiAccent' size='16' class='ma-0' :width='1'></v-progress-circular>
                                            </template>
                                            <template v-else>
                                                <span v-if='value.time' class='caption font-weight-light'>Обновлено <span class='font-weight-regular'>{{value.time}}</span></span>
                                                <span v-else class='caption font-weight-light'>Не обновлялось</span>
                                            </template>
                                        </div>
                                    </v-list-item-title>
                                </v-list-item-content!-->
                            </v-list-item>
                        </template>
                        <v-list-item v-for='(s,si) in value.places' :key="s.source_id" link class='pl-4'>
                            <v-list-item-action class='ml-4 mr-5'>
                                <v-icon small>{{s.connected? "mdi-check": "mdi-close"}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title class="align-center">
                                    <span v-if="s.active">
                                        {{s.source_name}} ({{s.source_type_provider}})
                                    </span>
                                    <span v-else style="color: red;">
                                        {{s.source_name}} ({{s.source_type_provider}})
                                    </span>
                                </v-list-item-title>
                                <template v-if="s.source_type_provider == 'Funnel'">
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_int.account_id'>
                                        <a :href='`https://app.funnel.io/#/account/${s.source_int.account_id}/exports/`'
                                           target='_blank'>К экспорту данных</a>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_int.source_id'>
                                        ID источника (внутренний): <span class='font-weight-regular'>{{s.source_int.source_id}}</span>
                                    </v-list-item-subtitle>
                                </template>

                                <template v-if="s.source_type_provider == 'JetStat'">
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_int.account_id'>
                                        <a :href='`https://app.jetstat.io/report/${s.source_int.account_id}`'
                                           target='_blank'>К экспорту данных</a>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_int.source_id'>
                                        ID источника (внутренний): <span class='font-weight-regular'>{{s.source_int.source_id}}</span>
                                    </v-list-item-subtitle>
                                </template>

                                <template v-if="s.source_type_provider == 'Artics'">
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_ext.account_id'>
                                        ID источника (внешний): <span class='font-weight-regular'>{{s.source_ext.account_id}}</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class='caption font-weight-light'
                                                          v-if='s.source_int.source_id'>
                                        ID источника (внутренний): <span class='font-weight-regular'>{{s.source_int.source_id}}</span>
                                    </v-list-item-subtitle>
                                </template>
                                <template v-if='s.source_type_id == "ga"'>
                                    <v-list-item-subtitle class='caption font-weight-light'>
                                        Ресурс: <span class='font-weight-regular'>{{s.source_ext.property_id}}</span>
                                    </v-list-item-subtitle>
                                </template>

                                <template v-if='s.source_type_id == "ga4"'>
                                    <v-list-item-subtitle class='caption font-weight-light'>
                                        Ресурс: <span class='font-weight-regular'>{{s.source_int.property_id}}</span>
                                    </v-list-item-subtitle>
                                </template>


                                <template v-else-if='s.source_type_id == "calltouch"'>
                                    <v-list-item-subtitle class='caption font-weight-light'>Идентификатор сайта: <span
                                        class='font-weight-regular'>{{s.source_ext.site_id}}</span>
                                    </v-list-item-subtitle>
                                </template>
                                <template v-else-if='s.source_type_id == "comagic"'>
                                    <v-list-item-subtitle class='caption font-weight-light my-0 pb-0'>Идентификатор
                                        сайта: <span class='font-weight-regular'>{{s.source_ext.site_id}}</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle class='caption font-weight-light my-0 pt-0'>Способ
                                        подключения: <span class='font-weight-regular'>{{s.source_int.auth_flow == "token"? "Токен":"Логин/Пароль"}}</span>
                                    </v-list-item-subtitle>
                                </template>
                                <template v-else-if='s.source_type_id == "gsheets"'>
                                    <v-list-item-subtitle class='caption font-weight-light'><a
                                        :href='s.source_ext.document_url' target='_blank'>Источник данных</a>
                                    </v-list-item-subtitle>
                                </template>
                                <template v-else-if='["adjust", "appsflyer"].includes(s.source_type_id)'>
                                    <v-list-item-subtitle class='caption font-weight-light'>Платформа: <span
                                        class='font-weight-regular'>{{s.source_ext.platform}}</span>
                                    </v-list-item-subtitle>
                                </template>
                                <v-list-item-subtitle>
                                    <span v-if='s.update_time' class='caption font-weight-light'>Обновлено <span
                                        class='font-weight-regular'>{{s.update_time}}</span></span>
                                    <span v-else class='caption font-weight-light'>Не обновлялось</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-content v-if="statplaceDeleteAllowed && s.source_type_provider != 'Funnel'">
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-menu
                                                v-model="s.startDateMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                                max-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="s.startDate"
                                                        label="Дата начала"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        clearable
                                                        @click:clear="s.startDate = null"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="s.startDate"
                                                    @input="s.startDateMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-menu
                                                v-model="s.endDateMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                                max-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="s.endDate"
                                                        label="Дата конца"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        clearable
                                                        @click:clear="s.endDate = null"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="s.endDate"
                                                    @input="s.endDateMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>


                            </v-list-item-content>

                            <!--                            <v-list-item-action title="Загрузить в Google Spreadsheet" v-if="s.source_type_provider != 'Funnel'">-->
                            <!--                                <v-btn class='mr-1' icon @click.stop.prevent='uploadToGoogleSpreadSheet(s)'>-->
                            <!--                                    <v-icon color='green'>mdi-google-spreadsheet</v-icon>-->
                            <!--                                </v-btn>-->
                            <!--                            </v-list-item-action>-->

                            <v-list-item-action title="Скачать Excel" v-if="s.source_type_provider != 'Funnel'">
                                <v-btn class='mr-1' icon @click.stop.prevent='downloadExcel(s)'
                                       :disabled="isExcelDownloading">
                                    <v-icon color='green'>mdi-file-excel</v-icon>
                                </v-btn>
                            </v-list-item-action>

                            <v-snackbar v-model="isExcelDownloading">Загрузка...</v-snackbar>

                            <v-list-item-action title="Обновить источник" v-if="statplaceDeleteAllowed && s.active">
                                <v-btn class='mr-1' icon @click.stop.prevent='sourceInit(s)'>
                                    <v-icon color='light-blue darken-1'>mdi-refresh</v-icon>
                                </v-btn>
                            </v-list-item-action>

                            <v-list-item-action title="Запустить источник" v-if="statplaceDeleteAllowed && !s.active">
                                <v-btn class='mr-1' icon @click.stop.prevent='enableSource(s)'>
                                    <v-icon color='green'>mdi-play</v-icon>
                                </v-btn>
                            </v-list-item-action>
                            <v-list-item-action title="Остановить источник" v-if="statplaceDeleteAllowed && s.active">
                                <v-btn class='mr-1' icon @click.stop.prevent='disableSource(s)'>
                                    <v-icon color='red accent-4'>mdi-stop</v-icon>
                                </v-btn>
                            </v-list-item-action>
                            <v-list-item-action v-if='statplaceDeleteAllowed && s.active'>
                                <v-btn class='mr-1' small icon
                                       @click.stop.prevent='cursorStatplace = s; visibility.update = true;'>
                                    <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                                </v-btn>
                            </v-list-item-action>
                            <v-list-item-action v-if='statplaceDeleteAllowed'>
                                <v-btn class='pa-0 ma-0' small icon
                                       @click.stop.prevent='cursorStatplace = s; visibility.delete = true;'>
                                    <v-icon small :color='$store.getters.uiAccentIcon'>delete_outline</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item :disabled='unconnectedStatplaces.length == 0' @click="connectStatplaces()"
                                 v-if='statplaceConnectAllowed && statplaces.length'>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Связать с базой данных</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-icon>compare_arrows</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
        <statplace-create :initialState.sync='visibility.create' :postAction='getProjectStatplaces'
                          :project='project'></statplace-create>
        <statplace-update :initialState.sync='visibility.update' :postAction='getProjectStatplaces'
                          :statplace='cursorStatplace'></statplace-update>
        <statplace-delete :initialState.sync='visibility.delete' :data='cursorStatplace'
                          :postAction='getProjectStatplaces' :projectId='project.project_id'></statplace-delete>
        <connection-details :initialState.sync='visibility.info' :data='project'></connection-details>
        <project-state :initialState.sync='visibility.state' :data='project'></project-state>
        <project-factors :initialState.sync='visibility.factors' :data='project'></project-factors>
    </v-layout>
</template>

<script>

    import CreateStatplace from '@/components/entities/statplaces/CreateDialog.vue';
    import UpdateStatplace from '@/components/entities/statplaces/UpdateDialog.vue';
    import DeleteStatplace from '@/components/entities/statplaces/DeleteDialog.vue';
    import ConnectionDetails from '@/components/entities/statplaces/ConnectionDetails.vue';
    import ProjectState from '@/components/entities/projects/State.vue';
    import ProjectFactors from '@/components/entities/projects/Factors.vue';

    import projectHandlers from '@/mixins/project'
    import {orderBy} from 'lodash-es'

    export default {
        name: 'ProjectStatplaces',
        props: ['data'],
        mixins: [projectHandlers],
        components: {
            'statplace-create': CreateStatplace,
            'statplace-update': UpdateStatplace,
            'statplace-delete': DeleteStatplace,
            'connection-details': ConnectionDetails,
            'project-state': ProjectState,
            'project-factors': ProjectFactors
        },
        data() {
            return {
                isExcelDownloading: false,
                meanings: {
                    app_tracker: 'Трекер для приложений',
                    web_tracker: 'Трекер для сайтов',
                    call_tracker: 'Коллтрекинг',
                    ad_cabinet: 'Рекламная платформа',
                    ext_table: 'Внешний источник данных'
                },
                visibility: {
                    update: false,
                    create: false,
                    delete: false,
                    info: false,
                    state: false,
                    factors: false
                },
                snackbar: false,
                snackbar2: false,
                snackbar3: false,
                isViewButtonDisabled: false,
                isFincardUploadButtonDisabled: false,
                isPmReportsUploadButtonDisabled: false,
                project: this.data,
                statplaces: [],
                showNonActive: false,
                cursorStatplace: {
                    source_ext: {},
                    source_int: {},
                    meta: {}
                },
                indicator: {
                    list: false,
                    sync: false,
                    updates: false
                },
                valid: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.'
                },
                exported_sources: []
            }
        },
        computed: {
            statplaceConnectAllowed() {
                return this.project.mode_statplaces != 'R'
            },
            statplaceCreateAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            statplaceDeleteAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            factorsAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces) && ['X', 'U'].includes(this.project.mode_persons)
            },
            groupedStatplaces() {
                const groups = this.$store.state.sourceTypes;
                const s = this.statplaces;
                let res = {};
                for (let i in orderBy(groups, 'source_type_name')) {
                    let places = [];
                    if (this.showNonActive) {
                        places = s.filter((f) => f.source_type_id == groups[i].source_type_id);
                    } else {
                        places = s.filter((f) => f.active && f.source_type_id == groups[i].source_type_id);
                    }
                    places = orderBy(places, "source_name", "asc");
                    let update_time = places.reduce((a, v) => a <= v.update_time ? v.update_time : a, '');
                    groups[i] = {
                        ...groups[i],
                        'time': update_time,
                        'places': places,
                    }
                }
                return groups.filter((g) => g.places.length);
            },
            unconnectedStatplaces() {
                return (this.statplaces || [{}]).filter((s) => !s.connected && s.active)
            }
        },
        watch: {
            data(value) {
                if (value) {
                    this.project = value
                    this.getProjectStatplaces()
                }
            }
        },
        methods: {

            uploadToGoogleSpreadSheet(s) {
                console.log(s)
            },
            downloadExcel(s) {
                const params = {
                    source_id: s.source_id
                };
                if (s.startDate) {
                    params['start_date'] = s.startDate;
                }
                if (s.endDate) {
                    params['end_date'] = s.endDate;
                }
                this.isExcelDownloading = true;
                this.$http.post(
                    this.$store.getters.endpoint + '/db/download_excel',
                    params,
                    {
                        headers: {
                            ...this.$store.state.restrictedHeaders,
                            ...{
                                'Content-Type': 'application/json;charset=UTF-8'
                            }
                        },
                        responseType: 'blob'
                    }
                ).then(r => {
                    let response = r.body;
                    const excelFile = new Blob([response], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const fileURL = window.URL.createObjectURL(excelFile)
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'file.xlsx');
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.isExcelDownloading = false;
                    // this.getProjectStatplaces();
                })
            },

            disableSource(s) {
                const params = {
                    source_id: s.source_id
                };
                this.$http.post(this.$store.getters.endpoint + '/db/disable_source', params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    console.log(response)
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.getProjectStatplaces();
                })
            },

            enableSource(s) {
                const params = {
                    source_id: s.source_id
                };
                this.$http.post(this.$store.getters.endpoint + '/db/enable_source', params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    console.log(response)
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.getProjectStatplaces();
                })
            },

            sourceInit(s) {
                const params = {
                    'login': this.$store.getters.userLogin,
                    'source_id': s.source_id,
                };
                if (s.startDate) {
                    params['d_start'] = s.startDate;
                }
                if (s.endDate) {
                    params['d_end'] = s.endDate;
                }
                if (s.source_int.hasOwnProperty('gac') && s.source_int.gac) {
                    params['route'] = 'gac'
                }
                this.$http.post(this.$store.getters.endpoint + '/db/init_source', params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    console.log(response)
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    this.getProjectStatplaces();
                })

            },
            updateView() {
                this.isViewButtonDisabled = true;
                this.$http.post(this.$store.getters.endpoint + '/db/update_view', {
                    'login': this.$store.getters.userLogin,
                    'project_id': this.project.project_id,
                }, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    this.snackbar = true;

                }).finally(() => {
                    setTimeout(() => {
                        this.snackbar = false;
                        this.isViewButtonDisabled = false;
                    }, 5000);
                })
            },
            updateFincards() {
                this.isFincardUploadButtonDisabled = true;
                this.$http.get(
                    this.$store.getters.endpoint + `/db/upload_fincards`, {
                        'login': this.$store.getters.userLogin,
                    }, {
                        headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                    }
                ).then(
                    r => {
                        this.snackbar2 = true;
                        console.log(r)
                    }
                ).finally(() => {
                    setTimeout(() => {
                        this.snackbar2 = false;
                        this.isFincardUploadButtonDisabled = false;
                    }, 5000);
                });
            },
            updatePMReports() {
                this.isPmReportsUploadButtonDisabled = true;
                this.$http.get(
                    this.$store.getters.endpoint + `/db/upload_pm`, {
                        'login': this.$store.getters.userLogin,
                    }, {
                        headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                    }
                ).then(
                    r => {
                        this.snackbar3 = true;
                        console.log(r)
                    }
                ).finally(() => {
                    setTimeout(() => {
                        this.snackbar3 = false;
                        this.isPmReportsUploadButtonDisabled = false;
                    }, 5000);
                });
            },
            getExportedSources() {
                this.indicator.list = true;
                this.getProjectPropertyPromise('export_sources').then((r) => {
                    let response = r.body
                    this.indicator.list = false
                    if (response.result) {
                        this.exported_sources = orderBy(response.data || [], 'sourceType')
                    } else {
                        console.log('error fetch project statplaces', response.data)
                    }
                });
            },
            getProjectStatplaces() {
                this.indicator.list = true;
                this.getProjectPropertyPromise('statplaces').then((r) => {
                    let response = r.body
                    this.indicator.list = false
                    if (response.result) {
                        this.statplaces = orderBy(response.data || [], 'source_id');
                        this.statplaces.forEach(p => {
                            p.startDate = new Date().toISOString().substr(0, 10);
                            p.endDate = new Date().toISOString().substr(0, 10);
                        });
                        this.getStatplacesUpdates()
                        //this.getExportedSources()
                    } else {
                        console.log('error fetch project statplaces', response.data)
                    }
                });
            },
            getStatplacesUpdates() {
                this.indicator.updates = true
                this.$http.post(this.$store.getters.endpoint + '/db/updates', {
                    'login': this.$store.getters.userLogin,
                    'project_table': this.project.project_table,
                    'project_id': this.project.project_id,
                    'dataset_name': this.project.dataset_name
                }, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then((r) => {
                    let response = r.body
                    this.indicator.updates = false
                    if (response.result) {
                        this.statplaces = orderBy(response.data || [], 'source_id');
                        this.statplaces.forEach(p => {
                            this.statplaces.forEach(p => {
                                p.startDate = new Date().toISOString().substr(0, 10);
                                p.endDate = new Date().toISOString().substr(0, 10);
                            });
                        });
                    } else {
                        console.log('error fetch statplaces updates', response.data)
                    }
                });
            },
            connectStatplaces() {
                this.indicator.sync = true;
                this.$http.post(this.$store.getters.endpoint + '/db/connect', {
                    'login': this.$store.getters.userLogin,
                    'project_table': this.project.project_table,
                    'project_name': this.project.project_name,
                    'project_id': this.project.project_id,
                    'places': this.unconnectedStatplaces
                }, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then((r) => {
                    let response = r.body
                    this.indicator.sync = false
                    if (response.result) {
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'sync',
                                target: 'project_source'
                            },
                            once: false
                        })
                        this.getProjectStatplaces()
                    } else {
                        console.log('error sync statplaces', response.data)
                    }
                });
            }
        },
        mounted() {
            this.getProjectStatplaces();
            this.$store.dispatch('fillSourceTypes')
        }
    }
</script>
